import React from 'react';
import { observer } from 'mobx-react-lite';
import { useFormContext } from 'react-hook-form';
import { EventPanelFormType } from '@mark43/cad-api';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { FormBody } from '../../../forms/integrated-form-components/form-body';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { EventPanelTab } from '../components/event-panel-tab';
import { TabBody } from '../../../panels/entity-panels/tabs/tab-body';
import { InvolvedPropertyBox } from '../../event-panel-form/involved-person-vehicle-fields/property/event-panel-form-property-box';

export const InvolvedPropertiesTab = observer(function InvolvedPropertyTab() {
    const eventForm = useFormContext<EventPanelFormType>();
    const eventPanelOptions = useBootstrapState().eventPanelOptions;
    const { hasMergedEvents } = useEventMetadataStore().state.metadata ?? {};

    return (
        <EventPanelTab title="Involved Property">
            <TabBody>
                <FormBody formBodyStyle={{ marginTop: '0rem' }}>
                    <>
                        <InvolvedPropertyBox
                            baseKey="firearms"
                            propertyLabel="Firearms"
                            addButtonText="Add Firearm"
                            noMembersText="No Firearms"
                            eventForm={eventForm}
                            eventPanelOptions={eventPanelOptions!}
                            hideDexFields={true}
                            allowMembersControl={true}
                        />
                        <InvolvedPropertyBox
                            baseKey="drugs"
                            propertyLabel="Drugs"
                            addButtonText="Add Drug"
                            noMembersText="No Drugs"
                            eventForm={eventForm}
                            eventPanelOptions={eventPanelOptions!}
                            hideDexFields={true}
                            allowMembersControl={true}
                        />
                        <InvolvedPropertyBox
                            baseKey="otherItems"
                            propertyLabel="Other Items"
                            addButtonText="Add Other Item"
                            noMembersText="No Other Items"
                            eventForm={eventForm}
                            eventPanelOptions={eventPanelOptions!}
                            hideDexFields={true}
                            allowMembersControl={true}
                        />
                        {hasMergedEvents && (
                            <>
                                <InvolvedPropertyBox
                                    baseKey="mergedFirearms"
                                    propertyLabel="Merged Firearms"
                                    noMembersText="No Merged Firearms"
                                    eventForm={eventForm}
                                    eventPanelOptions={eventPanelOptions!}
                                    hideDexFields={true}
                                />
                                <InvolvedPropertyBox
                                    baseKey="mergedDrugs"
                                    propertyLabel="Merged Drugs"
                                    noMembersText="No Merged Drugs"
                                    eventForm={eventForm}
                                    eventPanelOptions={eventPanelOptions!}
                                    hideDexFields={true}
                                />

                                <InvolvedPropertyBox
                                    baseKey="mergedOtherItems"
                                    propertyLabel="Merged Other Items"
                                    noMembersText="No Merged Other Items"
                                    eventForm={eventForm}
                                    eventPanelOptions={eventPanelOptions!}
                                    hideDexFields={true}
                                />
                            </>
                        )}
                    </>
                </FormBody>
            </TabBody>
        </EventPanelTab>
    );
});
